var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2638_13585",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2638_13585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 10.667L4.66699 7.33366L5.60033 6.36699L7.33366 8.10033V2.66699H8.66699V8.10033L10.4003 6.36699L11.3337 7.33366L8.00033 10.667ZM4.00033 13.3337C3.63366 13.3337 3.31977 13.2031 3.05866 12.942C2.79755 12.6809 2.66699 12.367 2.66699 12.0003V10.0003H4.00033V12.0003H12.0003V10.0003H13.3337V12.0003C13.3337 12.367 13.2031 12.6809 12.942 12.942C12.6809 13.2031 12.367 13.3337 12.0003 13.3337H4.00033Z",
    fill: "black",
    fillOpacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.52191f6aabecd7eaf38d00464faef78f.svg";
export { ForwardRef as ReactComponent };